import React, { useEffect, useRef, useState } from "react";
import "chart.js/auto";
import { Chart } from "react-chartjs-2";
import { connect } from "react-redux";
import { withToast } from "../contexts/toastr.context";
import leftIcon from "../_assets/images/left_icon.png";
import exportIcon from "../_assets/images/export.png";
import { Button } from "../_components/button.component";
import { useReactToPrint } from "react-to-print";
import Select from "react-select";
import chartColors from "./../_config/chart-colors.json";
import { SurveysService } from "../_service/surveys.service";
import { Loader } from "../_components/loader.component";
import ChartDataLabels from "chartjs-plugin-datalabels";
import moment from "moment";

// Chart.register(ChartDataLabels);

export const SURVEY_DETAILS_ROUTE = "/survey-details";

export function getSurveyDetailsRoute(surveyId) {
  return "/survey-details" + "?surveyId=" + surveyId;
}

let pieOptions = {
  maintainAspectRatio: false,
  scales: {
    x: {
      display: false,
      grid: {
        display: false,
      },
    },
    y: {
      display: false,
      grid: {
        display: false,
      },
    },
  },
  plugins: {
    legend: {
      display: false,
    },
    datalabels: {
      display: true,
      color: function (ctx) {
        return ctx.dataset.backgroundColor[ctx.dataIndex];
      },
      anchor: "end",
      align: "end",
      font: {
        weight: "bold",
        size: 12,
      },
      formatter: function (value, context) {
        let envLabe = context.chart.data.labels[context.dataIndex];
        return envLabe.toString() + " - " + value + "%";
      },
    },
    outlabels: {
      stretch: 25,
      text: "%l - %p",
      font: {
        resizable: true,
        minSize: 12,
        maxSize: 13,
      },
    },
  },
  layout: {
    padding: {
      top: 50,
      right: 15,
      bottom: 45,
      left: 15,
    },
  },
};

let lineOptions = {
  maintainAspectRatio: false,
  scales: {
    y: {
      ticks: { beginAtZero: true, stepSize: 10 },
    },
  },
  plugins: {
    legend: {
      display: false,
    },
    datalabels: {
      display: true,
      color: function (ctx) {
        return ctx?.dataset?.backgroundColor[ctx?.dataIndex];
      },
      anchor: "end",
      align: "end",
      font: {
        weight: "bold",
        size: 12,
      },
    },
  },
  layout: {
    padding: {
      top: 50,
      right: 15,
      bottom: 45,
      left: 15,
    },
  },
};

function SurveyDetailsPageComponent({ user, history }) {
  const searchParams = new URLSearchParams(window.location.search);
  const surveyId = searchParams.get("surveyId");
  const subFilterValues = {
    profession: [
      { label: "Nurse", value: "Nurse" },
      { label: "Patient Care Attendant", value: "Patient Care Attendant" },
      { label: "Physician", value: "Physician" },
      { label: "Resident Physician", value: "Resident Physician" },
      { label: "Physician’s Assistant", value: "Physician’s Assistant" },
      { label: "Respiratory Therapist", value: "Respiratory Therapist" },
      {
        label: "Occupational/Speech Therapist",
        value: "Occupational/Speech Therapist",
      },
      { label: "Physical Therapist", value: "Physical Therapist" },
      { label: "Nursing Student", value: "Nursing Student" },
      { label: "Medical Student", value: "Medical Student" },
      {
        label: "Physician’s Assistant Student",
        value: "Physician’s Assistant Student",
      },
      { label: "Other Student", value: "Other Student" },
      { label: "Other", value: "Other" },
    ],
    department: [
      { label: "Breast Care", value: "Breast Care" },
      { label: "Cancer Care", value: "Cancer Care" },
      { label: "Cardiac Care", value: "Cardiac Care" },
      { label: "Cardiopulmonary", value: "Cardiopulmonary" },
      { label: "Critical Care", value: "Critical Care" },
      { label: "Diagnostic Sleep Center", value: "Diagnostic Sleep Center" },
      { label: "Elderly Care", value: "Elderly Care" },
      { label: "Emergency Services", value: "Emergency Services" },
      { label: "ENT & Allergy", value: "ENT & Allergy" },
      { label: "Hospitalists", value: "Hospitalists" },
      { label: "Internal Medicine", value: "Internal Medicine" },
      {
        label: "Neurology and Neurosurgery",
        value: "Neurology and Neurosurgery",
      },
      {
        label: "Occupational, Physical, and Speech Therapy",
        value: "Occupational, Physical, and Speech Therapy",
      },
      { label: "Orthopedics", value: "Orthopedics" },
      { label: "Palliative Care", value: "Palliative Care" },
      { label: "Pediatrics", value: "Pediatrics" },
      { label: "Primary Care", value: "Primary Care" },
      { label: "Radiology", value: "Radiology" },
      { label: "Rehabilitation", value: "Rehabilitation" },
      { label: "Rheumatology", value: "Rheumatology" },
      { label: "Stroke Care", value: "Stroke Care" },
      { label: "Wound Care", value: "Wound Care" },
      { label: "Other", value: "Other" },
    ],
  };

  const [surveyData, setSurveyData] = useState(null);
  const [filterOptions, setFilterOptions] = useState([
    { label: "By Profession", value: "profession" },
    { label: "By Department", value: "department" },
  ]);
  const [selectedProfession, setSelectedProfession] = useState(null);
  const [selectedDepartment, setSelectedDepartment] = useState(null);
  const [detailedFilterOptions, setDetailedFilterOptions] = useState();
  const [questions, setQuestions] = useState([]);
  const componentRef = useRef();
  const [isSurveyLoading, setIsSurveyLoading] = useState(false);

  useEffect(() => {
    getSurveyData(surveyId);
  }, []);

  useEffect(() => {
    if (selectedProfession) {
      setSelectedDepartment(null);
      setDetailedFilterOptions(subFilterValues[selectedProfession?.value]);
    }
  }, [selectedProfession]);

  const getSurveyData = (surveyId) => {
    setIsSurveyLoading(true);
    SurveysService.getSurvey(user, surveyId)
      .then((resp) => {
        setSurveyData({
          dueDate: resp.dueDate,
          totalQuestions: resp.questionsCount,
          totalUsers: resp.allUsers,
          totalAnswers: resp.answerUserCount,
        });
        let allGraphData = [];
        resp.data.forEach((item, index) => {
          if (item.questionType.value !== "writtenAnswer") {
            let itemsData = [];
            let itemsLabels = [];
            item.type = "bar";
            if (item.data.length > 5) {
              item.data.forEach((d, index) => {
                let total = item.data.reduce((a, b) => a + b, 0);
                if (d > 0) {
                  itemsData.push(parseFloat((d / total) * 100).toFixed(2));
                  itemsLabels.push(item.labels[index]);
                }
              });
              item.data = itemsData;
              item.labels = itemsLabels;
              item.type = "pie";
            }
            allGraphData.push({
              ...item,
              isLoading: false,
              backgroundColor: chartColors.colors.filter(
                (data, ind) => ind < item.data.length
              ),
            });
          } else {
            allGraphData.push({
              ...item,
            });
          }
        });
        setQuestions(allGraphData);
        setIsSurveyLoading(false);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    pageStyle: `
      @media print {
          .pagebreak { page-break-before: always; }
          .hide-print-table {
            display: none !important;
          }
          .show-print-table {
            display: block !important;
          }
        },
        @page {
          size: A4 landscape;
        }
        @media print {
          @page {
            size: auto;
            margin: 5mm;
          }
        }`,
    removeAfterPrint: true,
  });

  // useEffect(() => {}, [questions]);

  const getSingleQuestionDetails = (que, questionIndex) => {
    let allQuestions = console.log(surveyId);
  };

  const getDueRemaining = (due) => {
    let timeDiff = moment(due).diff(moment(), "hours");
    let label = "";
    if (timeDiff <= 24 && timeDiff >= 0) {
      label = "Expiring Today";
    } else if (timeDiff > 24) {
      let days = Math.floor(timeDiff / 24);
      label = days <= 1 ? `${days} day` : `${days} days`;
    } else {
      label = "Survey Expired";
    }
    return label;
  };

  return (
    <div className="page-container ml-auto px-9 py-6 org-management-container survey-page-container">
      <div className="flex pb-4 back-btn-container items-center cursor-pointer">
        <div className="flex items-center w-11/12">
          <img src={leftIcon} alt="" onClick={() => history.push("/")} />
          <span
            className="ml-3 text-xl home-text t-grey"
            onClick={() => history.push("/survey")}>
            Survey
          </span>
        </div>
        <div className="text-right">
          <button
            onClick={handlePrint}
            className="flex px-4 py-2 text-white rounded-md items-center btn-primary">
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="mr-2 w-3">
              <path
                d="M14 11V14H2V11H0V14C0 15.1 0.9 16 2 16H14C15.1 16 16 15.1 16 14V11H14ZM13 7L11.59 5.59L9 8.17V0H7V8.17L4.41 5.59L3 7L8 12L13 7Z"
                fill="white"
              />
            </svg>
            Export
          </button>
        </div>
      </div>
      {!isSurveyLoading ? (
        <div
          className="survey-details-container"
          ref={componentRef}
          style={{ width: "88%" }}>
          <div>
            <div className="bg-white card px-11 py-9 relative rounded-lg w-96 w-full survey-overview-container">
              {/* Survey Overview Container */}
              <div>
                <div className="flex justify-between overview-label-container">
                  <p className="font-bold text-lg text-primary">
                    Survey Overview
                  </p>
                </div>
                <div className="flex mt-4 overview-counts-container">
                  <div className="w-1/3 pr-6">
                    <p className="text-base text-primary font-bold">
                      Total Completed
                    </p>
                    <label className="text-base t-grey font-bold">
                      {surveyData?.totalAnswers ? surveyData?.totalAnswers : 0}/
                      {surveyData?.totalUsers ? surveyData?.totalUsers : 0}{" "}
                      responses
                    </label>
                  </div>
                  <div className="w-1/3 border-left pl-6 pr-6">
                    <p className="text-base text-primary font-bold">
                      Days Remaining
                    </p>
                    <label className="text-base t-grey font-bold">
                      {getDueRemaining(surveyData?.dueDate)}
                    </label>
                  </div>
                  <div className="w-1/3 border-left pl-6">
                    <p className="text-base text-primary font-bold">
                      Total Questions
                    </p>
                    <label className="text-base t-grey font-bold">
                      {surveyData?.totalQuestions}{" "}
                      {surveyData?.totalQuestions === 1
                        ? "question"
                        : "questions"}
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
            {/* Questions Container */}
            <div>
              {questions.length > 0 &&
                questions.map((question, index) => {
                  return (
                    <div key={index}>
                      <div className="pagebreak"> </div>
                      <div className="bg-white card px-11 py-9 relative rounded-lg w-full survey-overview-container mt-2.5 mb-3">
                        <div className="flex justify-between overview-label-container">
                          <p className="font-bold text-lg t-grey w-6/12">
                            {`${index + 1}.`} {question.title}
                          </p>
                          {/* <Select
                            options={filterOptions}
                            className="filter-dropdown"
                            placeholder="Filter"
                            onChange={async (data) => {
                              setSelectedProfession(data);
                            }}
                            value={selectedProfession}
                          />
                          {selectedProfession ? (
                            <Select
                              options={detailedFilterOptions}
                              className="filter-dropdown"
                              onChange={async (data) => {
                                setSelectedDepartment(data);
                                getSingleQuestionDetails(question, index);
                              }}
                              value={selectedDepartment}
                            />
                          ) : (
                            <></>
                          )} */}
                        </div>
                        <div>
                          {question.questionType.value === "scale" ? (
                            <p className="font-bold text-lg t-grey">
                              ({question.options[0].start.value} =
                              {` ${question.options[0].start.label}`} ;
                              {` ${question.options[0].end.value}`} =
                              {` ${question.options[0].end.label}`})
                            </p>
                          ) : (
                            <></>
                          )}
                        </div>
                        <div
                          className={`mt-4 ${
                            question.questionType.value !== "writtenAnswer"
                              ? "flex overview-chart-container"
                              : "w-full"
                          }`}>
                          {question.questionType.value !== "writtenAnswer" ? (
                            <>
                              {question?.data.length > 0 ? (
                                <Chart
                                  type={question.type}
                                  style={{
                                    minHeight: "400px",
                                    maxHeight: "400px",
                                  }}
                                  plugins={[ChartDataLabels]}
                                  data={{
                                    labels: question?.labels,
                                    datasets: [
                                      {
                                        data: question?.data,
                                        backgroundColor:
                                          question?.backgroundColor,
                                      },
                                    ],
                                    text: "23%",
                                  }}
                                  options={
                                    question?.type !== "pie"
                                      ? lineOptions
                                      : pieOptions
                                  }
                                />
                              ) : (
                                <div
                                  className="w-full items-center flex"
                                  style={{
                                    minHeight: "50px",
                                    maxHeight: "50px",
                                  }}>
                                  {/* <Loader loaderWidth="w-full" /> */}
                                  <p className="text-primary w-full">
                                    Data not found
                                  </p>
                                </div>
                              )}
                            </>
                          ) : (
                            <>
                              {question.answeredUser.length > 0 ? (
                                <div>
                                  <div className="flex p-2 shadow w-full">
                                    <div className="font-bold t-grey w-40">
                                      Date
                                    </div>
                                    <div className="font-bold t-grey w-40">
                                      Time
                                    </div>
                                    <div className="font-bold t-grey w-3/4">
                                      Submission
                                    </div>
                                  </div>
                                  <div
                                    className="hide-print-table mt-2 overflow-y-auto"
                                    style={{ maxHeight: "120px" }}>
                                    {question.answeredUser.map((ans) => {
                                      return (
                                        <div className="w-full flex p-2">
                                          <p className="w-40 t-grey">
                                            {moment(ans.created).format(
                                              "ddd, MM/DD/YYYY"
                                            )}
                                          </p>
                                          <p className="w-40 t-grey">
                                            {moment(ans.created).format("LT")}
                                          </p>
                                          <div className="w-3/4 whitespace-nowrap overflow-x-auto">
                                            <p className="t-grey">
                                              {ans.answer}
                                            </p>
                                          </div>
                                        </div>
                                      );
                                    })}
                                  </div>
                                  <div className="show-print-table mt-2 hidden">
                                    {question.answeredUser.map((ans) => {
                                      return (
                                        <div className="w-full flex p-2">
                                          <p className="w-40 t-grey">
                                            {moment(ans.created).format(
                                              "ddd, MM/DD/YYYY"
                                            )}
                                          </p>
                                          <p className="w-40 t-grey">
                                            {moment(ans.created).format("LT")}
                                          </p>
                                          <div className="w-3/4">
                                            <p className="t-grey">
                                              {ans.answer}
                                            </p>
                                          </div>
                                        </div>
                                      );
                                    })}
                                  </div>
                                </div>
                              ) : (
                                <div
                                  className="w-full items-center flex"
                                  style={{
                                    minHeight: "50px",
                                    maxHeight: "50px",
                                  }}>
                                  {/* <Loader loaderWidth="w-full" /> */}
                                  <p className="text-primary w-full">
                                    Data not found
                                  </p>
                                </div>
                              )}
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  );
                })}
            </div>
          </div>
        </div>
      ) : (
        <Loader />
      )}
    </div>
  );
}

const SurveyDetailsPage = withToast(
  connect((state) => ({
    user: state.auth,
    organization: state.orgData,
  }))(SurveyDetailsPageComponent)
);

export default SurveyDetailsPage;
